export const IS_LOGIN = 'IS_LOGIN';
export const IS_LOGOUT = 'IS_LOGOUT';

export const LOGIN = 'LOGIN';
export const SUCCESS_LOGIN = 'SUCCESS_LOGIN';
export const FAIL_LOGIN = 'FAIL_LOGIN';

export const LOGOUT = 'LOGOUT';
export const SUCCESS_LOGOUT = 'SUCCESS_LOGOUT';
export const FAIL_LOGOUT = 'FAIL_LOGOUT';

export const CHOOSE_SIGNIN_SHOP = 'CHOOSE_SIGNIN_SHOP';
export const SELECT_SIGNIN_SHOP = 'SELECT_SIGNIN_SHOP';

export const SEND_FORGET_PASSWORD_MAIL = 'SEND_FORGET_PASSWORD_MAIL';
export const SUCCESS_FORGET_PASSWORD_MAIL = 'SUCCESS_FORGET_PASSWORD_MAIL';
export const FAIL_FORGET_PASSWORD_MAIL = 'FAIL_FORGET_PASSWORD_MAIL';
